import {Routes} from 'constants/routes';

import {useEffect} from 'react';

import Icon from 'components/Icon/Icon';
import OverviewHeader from 'components/OverviewHeader/OverviewHeader';
import {Tabs} from 'components/Tabs/Tabs';
import {useGlobalState} from 'hooks/useGlobalState';
import useMediaQuery from 'hooks/useMediaQuery';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import LayoutPage from 'layouts/LayoutPage/LayoutPage';
import {setPubEditorsAC} from 'pages/pubPagesView/store/pubPageSlice';
import {getPubEditorsACS} from 'pages/pubPagesView/store/requests';
import {useNavigate} from 'react-router-dom';
import './Pub.scss';
import {setNavigationTitleAC} from 'store/app/appSlice';

import {PageEditorDesktop} from './PageEditorDesktop/PageEditorDesktop';

const Pub = () => {
  const dispatch = useSetGlobalState();
  const {managedPub} = useGlobalState((state) => state.managedPub);
  const {pubEditors} = useGlobalState((state) => state.pubPage);
  const navigate = useNavigate();

  const isTabletOrMobileScreen = useMediaQuery('(min-width: 991px)');

  useEffect(() => {
    dispatch(setNavigationTitleAC('pub'));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (managedPub) dispatch(getPubEditorsACS({pubId: managedPub.id, ...pubEditors.filters}));

    return () => {
      dispatch(setPubEditorsAC([]));
    };
    // eslint-disable-next-line
  }, [managedPub?.id, pubEditors.filters]);

  return (
    <LayoutPage>
      <div className="pub-page__layout">
        <OverviewHeader
          name={managedPub?.attributes?.name || ''}
          description={managedPub?.attributes?.description || ''}
          country={managedPub?.attributes?.country || ''}
          city={managedPub?.attributes?.city || ''}
          address={managedPub?.attributes?.address || ''}
          phone={managedPub?.attributes?.phone || ''}
          email={managedPub?.attributes?.email || ''}
          website={managedPub?.attributes?.website || ''}
          facebook={managedPub?.attributes?.facebook || ''}
          instagram={managedPub?.attributes?.instagram || ''}
          logo={managedPub?.attributes?.pub_logo}
          handleEdit={() => navigate(Routes.PUB_EDIT)}
          IconElement={<Icon icon="image-placeholder" />}
        />
        {isTabletOrMobileScreen && <Tabs tabContent={<PageEditorDesktop pubEditors={pubEditors.list} />} />}
      </div>
    </LayoutPage>
  );
};

export default Pub;
